export default "__VITE_ASSET__cb7ae6b6__"